type Props = {
  placeHolder?: string;
  searchTerm: string;
  setSearchTerm: (searchTerm: string) => void;
};

export const SearchBar = ({
  searchTerm,
  setSearchTerm,
  placeHolder = "Search",
}: Props) => (
  <input
    className="outline-hidden w-27 small-mobile:w-30 desktop:w-50 bg-gray-900 text-white h-7 desktop:h-[34px] pl-3 rounded-lg shadow-hard placeholder:text-secondary"
    placeholder={placeHolder}
    value={searchTerm}
    onChange={(e) => setSearchTerm(e.target.value)}
    onKeyDown={(e) => {
      if (e.key === "Escape") {
        setSearchTerm("");
        e.currentTarget.blur();
      }
    }}
  />
);
